import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Courses from "./components/Courses";
import WhyJoin from "./components/WhyJoin";
import Toppers from "./components/Toppers";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";

import { Helmet } from "react-helmet";

function App() {
  return (
    <>
      <Helmet>
        <title>Orion Academy Colaba | Best Tuition Classes in Colaba Mumbai</title>
        <meta
          name="description"
          content="Orion Academy is one of the best tuition classes in Colaba Mumbai for school, commerce and science students. Admissions open now."
        />
      </Helmet>

      <Navbar />
      <Hero />
      <About />
      <Courses />
      <WhyJoin />
      <Toppers />
      <Contact />
      <Footer />
    </>
  );
}

export default App;